import React, { useMemo, useEffect, useRef, useState } from "react";
import "../assets/css/home.css";
import "../assets/css/Style.css";

import menuData from "../assets/menu-data";

import Programmes from "../home-components/Programmes";
import Alumni from "../home-components/Alumni";
import Recruiters from "../home-components/Recruiters";
import Awards from "../home-components/Awards";
import Facilities from "../home-components/Facilities";
import BlogsFAQ from "../home-components/BlogsFAQ";

import logo from "../assets/img/logo.webp";
import logoWhite from "../assets/img/logo-white.webp";

const utilityLinks = [
  { title: "Student Login", url: "/student-login" },
  { title: "NAAC", url: "/naac" },
  { title: "IQAC", url: "/iqac" },
  { title: "e-Library", url: "/e-library" },
  { title: "Ph.D Research", url: "/phd-research" },
  { title: "Pay Online", url: "/pay-online" },
];

export default function Header() {
  const [menu, setMenu] = useState(null);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [mobileSection, setMobileSection] = useState(null);
  const [scrolled, setScrolled] = useState(false);
  const touchStart = useRef(0);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = mobileOpen ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [mobileOpen]);

  const allSchools = [];

  menuData.Programmes.groups.forEach(element => {
    element.links.forEach(link => {
      allSchools.push(link);
    })
  });

  const [activeGroup, setActiveGroup] = useState(
    menuData.Programmes.groups[0]
  );

  const [activeSchool, setActiveSchool] = useState(allSchools[0]);
  const [hoveredSchool, setHoveredSchool] = useState(null);

  useEffect(() => {
    if (menu === "Programmes") {
      setActiveSchool(allSchools[0]);
    }
  }, [menu]);

  return (
    <main>
      <header
        className={`site-header-inner ${scrolled ? "is-scrolled" : ""}`}
        onMouseLeave={() => setMenu(null)}
      >
        <div className="nav-shell">
          <a className="brand" href="/" aria-label="ISBM University home">
            <img src={logo} className="brand-logo" alt="ISBM University" />
          </a>

          <div className="nav-stack">
            <div className="utility-bar">
              <nav aria-label="Utility navigation">
                {utilityLinks.map((link) => (
                  <a key={link.title} href={link.url}>
                    {link.title}
                  </a>
                ))}
              </nav>

              <div className="utility-actions">
                <a href="tel:+919373199999" className="phone">
                  <span>Call us</span> +91 93731 99999
                </a>

                <a href="/apply" className="utility-apply">
                  Apply Online <span>↗</span>
                </a>
              </div>
            </div>

            <nav className="primary-nav" aria-label="Primary navigation">
              {Object.keys(menuData).map((item) => (
                <button
                  key={item}
                  className={menu === item ? "active" : ""}
                  onMouseEnter={() => setMenu(item)}
                  onFocus={() => setMenu(item)}
                  aria-expanded={menu === item}
                >
                  {item}
                  <span>
                    <i className="ti ti-chevrons-down"></i>
                  </span>
                </button>
              ))}

              <button className="search-btn" aria-label="Search">
                <svg viewBox="0 0 24 24">
                  <circle cx="11" cy="11" r="6.5" />
                  <path d="m16 16 4 4" />
                </svg>
              </button>
            </nav>
          </div>

          <div className="mobile-actions">
            <a href="/apply" className="mini-apply">
              Apply
            </a>

            <button
              className={`menu-toggle ${mobileOpen ? "open" : ""}`}
              onClick={() => setMobileOpen(!mobileOpen)}
              aria-expanded={mobileOpen}
              aria-label="Toggle menu"
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>

        <div
          className={`mega-menu ${menu ? "open" : ""}`}
          role="region"
          aria-label="Navigation submenu"
        >
          {menu && (
            <div className="mega-inner" key={menu}>
              <div className="mega-intro">
                <span className="mega-eyebrow">{menuData[menu].eyebrow}</span>

                <h2>{menuData[menu].title}</h2>

                <p>{menuData[menu].description}</p>

                <a href={menuData[menu].url || "#"}>
                  Overview <span>→</span>
                </a>
              </div>

              {menu === "Programmes" ? (
                <>
                  <div className="mega-group mega-relative">
                    <h3>{menuData.Programmes.groups[0].title}</h3>

                    {menuData.Programmes.groups[0].links.map((school) => (
                      <div
                        key={school.url}
                        className="school-item"
                        onMouseEnter={() => setHoveredSchool(school)}
                        onMouseLeave={() => setHoveredSchool(null)}
                      >
                        <a href={school.url}>
                          {school.title}
                          {school.courses && <span>›</span>}
                        </a>

                        {hoveredSchool?.url === school.url &&
                          school.courses?.length > 0 && (
                            <div className="course-dropdown">
                              {school.courses.map(course => (
                                <a key={course.url} href={course.url}>
                                  {course.title}
                                </a>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                  <div className="mega-group mega-relative-2">
                    <h3>{menuData.Programmes.groups[1].title}</h3>

                    {menuData.Programmes.groups[1].links.map((school) => (
                      <div
                        key={school.url}
                        className="school-item"
                        onMouseEnter={() => setHoveredSchool(school)}
                        onMouseLeave={() => setHoveredSchool(null)}
                      >
                        <a href={school.url}>
                          {school.title}
                          {school.courses && <span>›</span>}
                        </a>

                        {hoveredSchool?.url === school.url &&
                          school.courses?.length > 0 && (
                            <div className="course-dropdown">
                              {school.courses.map(course => (
                                <a key={course.url} href={course.url}>
                                  {course.title}
                                </a>
                              ))}
                            </div>
                          )}
                      </div>
                    ))}
                  </div>
                </>
              ) : (
                menuData[menu].groups.map((group) => (
                  <div className="mega-group" key={group.title}>
                    <h3>{group.title}</h3>

                    {group.links.map((link) => (
                      <a key={link.url} href={link.url}>
                        {link.title}
                      </a>
                    ))}
                  </div>
                ))
              )}

              <a href={menuData[menu].url || "#"} className="mega-feature">
                <img src={menuData[menu].image} alt={menu} />

                <span>
                  <small>Featured</small>
                  <strong>Experience our university</strong>
                  <i>Explore now →</i>
                </span>
              </a>
            </div>
          )}
        </div>
      </header>

      <div
        className={`mobile-panel ${mobileOpen ? "open" : ""}`}
        aria-hidden={!mobileOpen}
      >
        <div className="mobile-utility">
          {utilityLinks.map((link) => (
            <a key={link.url} href={link.url}>
              {link.title}
            </a>
          ))}

          <a href="tel:+919373199999">Call Us</a>
        </div>

        <nav aria-label="Mobile navigation">
          {Object.entries(menuData).map(([item, data]) => (
            <div className="mobile-menu-item" key={item}>
              <button
                onClick={() =>
                  setMobileSection(mobileSection === item ? null : item)
                }
                aria-expanded={mobileSection === item}
              >
                {item}
                <span>{mobileSection === item ? "−" : "+"}</span>
              </button>

              <div
                className={`mobile-sub ${mobileSection === item ? "open" : ""}`}
              >
                {data.groups.map((group) => (
                  <div className="mobile-sub-group" key={group.title}>
                    <h6>{group.title}</h6>

                    {group.links.map((link) => (
                      <a href={link.url} key={link.url}>
                        {link.title}
                      </a>
                    ))}
                  </div>
                ))}

                <a href={data.url} className="mobile-overview">
                  View {item} →
                </a>
              </div>
            </div>
          ))}
        </nav>

        <a className="mobile-cta" href="/apply">
          Begin your application <span>→</span>
        </a>
      </div>
    </main>
  );
}
